import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import SplitText from '@/vendors/bonus-files-for-npm-users/umd/SplitText' // eslint-disable-line
import BtnLink from '@/components/BtnLink'
import ParallaxImg from '@/components/ParallaxImg'
import style from './style'

const useStyles = createUseStyles(style)

const CoverProduct = ({
  className,
  img,
  pretitle,
  text,
  title,
  onBookClick,
}) => {
  const classes = useStyles()
  const strings = useSelector((state) => state.language.string)

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.imageWrapper}>
        {img && (
          <ParallaxImg
            img={img}
            alt={title}
          />
        )}
      </div>
      <div className={classes.infoWrapper}>
        {pretitle && (
          <div
            className={classes.pretitle}
            dangerouslySetInnerHTML={{ __html: pretitle }}
          />
        )}
        {title && (
          <h1
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {text && (
          <div
            className={classes.text}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        <div className={classes.btnWrapper}>
          <BtnLink
            link={strings.storefinder_link}
            label={strings.storefinder_label}
            theme="light"
            fill
          />
          {onBookClick ? (
            <BtnLink
              onClick={onBookClick}
              label={strings.appointment_label}
              theme="light"
            />
          ) : (
            <BtnLink
              link={strings.appointment_link}
              label={strings.appointment_label}
              theme="light"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CoverProduct
